import styles from './Avatar.module.css'

const AVATAR_PALETTE = [
  '#E05A4E', '#E08A4E', '#E0C44E', '#6DBE6D',
  '#4E9EE0', '#7B6DE0', '#C44EBE', '#4EC4C4',
]

function hashColor(seed) {
  let h = 0
  const s = String(seed || '')
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return AVATAR_PALETTE[h % AVATAR_PALETTE.length]
}

function initials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

/**
 * Avatar — a circular initials badge with a name-hashed background color. Used for the
 * "Created by" field and person rows in the ownership timeline.
 *
 * Props:
 *   name {string}
 *   size {number}  — diameter in px (default 28)
 */
export default function Avatar({ name, size = 28 }) {
  return (
    <span
      className={styles.avatar}
      style={{ backgroundColor: hashColor(name), width: size, height: size, fontSize: size * 0.4 }}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  )
}
